export default "__VITE_ASSET__ea791459__"